import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetServiceConfig = {
  name: "Asset",
  annotations: []
} as ServiceConfig;